'use client';

import { useEffect, useState, type RefObject } from 'react';

export const TICK_SPACING = 4;
const VISIBLE_TURN = 64 / 128;

export const useCompassScale = (
  compassRef: RefObject<HTMLDivElement | null>
) => {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const compass = compassRef.current;
    if (!compass) return;

    const observer = new ResizeObserver(([entry]) => {
      setWidth(entry.contentRect.width);
    });
    observer.observe(compass);
    return () => observer.disconnect();
  }, [compassRef]);

  const visibleTicks = Math.ceil(width / TICK_SPACING);
  const ticksPerTurn = Math.max(
    8,
    Math.round(visibleTicks / VISIBLE_TURN / 8) * 8
  );

  return { visibleTicks, ticksPerTurn, tickSpacing: TICK_SPACING };
};
